import FormCheckboxInput from 'components/common/forms/FormCheckboxInput';
import styles from 'styles/components/pages/chart/QuarantCheckbox.module.scss';

type TProps = {
  name: string;
  readOnly?: boolean;
};

const QuarantCheckbox = ({ name, readOnly }: TProps) => {
  const checkboxes = Array.from({ length: 4 }, (_, index) => index + 1);

  return (
    <div className={styles.custom_checkbox_container}>
      {checkboxes.map((index) => (
        <div key={index} className={styles[`quadrant${index}`]}>
          <FormCheckboxInput
            name={name}
            multiple={true}
            value={index.toString()}
            readOnly={readOnly}
          />
        </div>
      ))}
    </div>
  );
};

export default QuarantCheckbox;
